<template>
  <ModalCard>
    <template #body>
      <div class="columns is-full-width">
        <div class="column is-half">
          <FormMessageInput
            v-model="message"
            :placeholder="$t('messages.type-in-or-paste-a-message')"
          />
        </div>
        <div class="column is-half">
          <p
            class="has-border-light is-radius-medium is-full-height p-3 html-preview no-scrollbar is-relative"
          >
            {{ message }}
            <ButtonView
              v-show="message.length"
              type="is-light"
              class="is-absolute xy-b-10 xy-r-10"
              @click="copyToClipboard"
              :data-e2e="MessageCypressAttribute.buttons.COPY_TO_CLIPBOARD"
            >
              <span class="is-relative xy-b-2">{{ $t('messages.copy-to-clipboard') }}</span>
            </ButtonView>
          </p>
        </div>
      </div>
    </template>
  </ModalCard>
</template>

<script>
import { ModalMixin } from '@/modules/core/ui/mixins/ModalMixin';
import FormMessageInput from '@/modules/core/form/components/FormMessageInput.vue';
import ModalCard from '@/modules/core/ui/components/ModalCard.vue';
import ToastService from '@/modules/core/ui/services/ToastService';
import { MessageCypressAttribute } from '@/modules/messenger/_modules/message/constants/MessageCypressAttribute';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'RichTextEditorToolModal',
  mixins: [ModalMixin],
  components: {
    ButtonView,
    ModalCard,
    FormMessageInput
  },
  static: {
    MessageCypressAttribute
  },
  data() {
    return {
      message: ''
    };
  },
  methods: {
    copyToClipboard() {
      navigator?.clipboard.writeText(this.message);
      ToastService.show(this.$t('messages.copied-to-clipboard'));
    }
  }
};
</script>

<style scoped>
:deep(.modal-card-body) {
  display: flex;
  justify-content: center;
}

:deep(.ql-editor) {
  height: var(--ce-350px) !important;
}

:deep(.html-preview) {
  max-height: var(--ce-425px) !important;
  overflow-y: scroll;
}
</style>
